const offreInterface = {
  designation: "",
  prixMois: 0,
  prixAnnee: 0,
  access: [""],
};

export default offreInterface;
